import { renderWindowGeneratorBaySchematicToPngBlob, renderWindowGeneratorPayloadToPngBlob } from '../../../utils/windowGeneratorExport';
import { resolveExportWindowGeneratorPayload } from '../utils/visualDesignerPayloadResolution';

export function buildLatestWindowGeneratorPayloadFromMeta(meta: any): any {
  return resolveExportWindowGeneratorPayload(meta);
}

export function isBayLikePayload(payload: any): boolean {
  if (!payload || typeof payload !== 'object') return false;
  return String(payload?.root?.preset || '').trim().toLowerCase() === 'bay';
}

export async function renderWindowGeneratorImageBlobs(payload: any): Promise<{
  presentationExternal: Blob;
  presentationInternal: Blob;
  designExternal: Blob;
  designInternal: Blob;
  baySchematic: Blob | null;
}> {
  const [presentationExternal, presentationInternal, designExternal, designInternal] = await Promise.all([
    renderWindowGeneratorPayloadToPngBlob(payload, { view: 'external', mode: 'presentation', widthPx: 700 }),
    renderWindowGeneratorPayloadToPngBlob(payload, { view: 'internal', mode: 'presentation', widthPx: 700 }),
    renderWindowGeneratorPayloadToPngBlob(payload, { view: 'external', mode: 'design', widthPx: 860 }),
    renderWindowGeneratorPayloadToPngBlob(payload, { view: 'internal', mode: 'design', widthPx: 860 }),
  ]);

  const baySchematic = isBayLikePayload(payload)
    ? await renderWindowGeneratorBaySchematicToPngBlob(payload).catch(() => null)
    : null;

  return {
    presentationExternal,
    presentationInternal,
    designExternal,
    designInternal,
    baySchematic,
  };
}
